
Locales.$inject = ['$scope', '__env', 'toastr', 'httpService', 'readCookie'];angular
	.module('app')
	.component('localesComponent', {
		templateUrl: 'modules/localization/components/locales/locales.html',
		controller: Locales
	});

/**
 * Code supporting the kendo grid that displays locales
 * and performs CRUD opperations
 *
 * @class Locales
 * @param { service } $scope - The scope of the component.
 * @param { service } __env - The environment configuration. 
 * @param { service } toastr - The third party toaster service.
 * @param { service } httpService - The http service used to make asynchronous rest calls
 * @param { service } readCookie - reads cookie variables
 */
function Locales($scope, __env, toastr, httpService, readCookie) {	 	

	// columns of the grid
	var columns = [
		{
			field: 'code',
			title: 'Code',
			width: '15%'
		}, 
		{
			field: 'name',
			title: 'Name',
			width: '26%'
		}, 
		{
			field: 'nativeName',
			title: 'Native Name',
			width: '26%'
		},
		{ 
			command: ['edit', { text: 'Delete', click: deleteItem, template: "<a class='k-button k-button-icontext k-grid-Delete' href='\\#' ><span class=''></span>Delete</a>" }], 
			title: '&nbsp;', 
			width: '30%'}
	];

	// model to bind to
	var model = { id: 'localeId', 
					fields : {
						'code': { type: 'string' },
						'name': { type: 'string'},
						'nativeName': { type: 'string'}
					}
				}; 

	$scope.pageTitle = 'Locales';

	$scope.localesOptions = { 
        columnMenu: false,        
        columns: columns,        
        editable: {
	        mode: 'popup',
	        template: kendo.template(angular.element(document).find('#localeEditGridTemplate').html())
	    },
	    edit: function (e) 
		{
		    var editWindow = this.editable.element.data('kendoWindow');
		    editWindow.wrapper.css({ width: 300 });
		    //hack: change the edit-form-container width to 100% so window width is the actual width of whole window; else this defaults to 400px and scrolls within window
		    editContainer = this.editable.element.find('.k-edit-form-container');
		    editContainer.css({ width: '100%'});
		},        
        filterable: {
            extra: false,
            operators: {
                string: {
                    contains: 'Contains',
                    eq: 'Is equal to'
                }
            }
        },
        groupable: false,        
        pageable: true,        
        save: saveEvent,
        scrollable: true,          
        sortable: true       
    };	

    // commented until the endpoints exist
    $scope.localesSource = 
    {	
    	//data: categories		
        error: function(e) { toastr.error('Could not get locales');},	        
		transport: {
			read: {				
				type: 'get',
				contentType: 'application/json',	
				url: __env.apiBaseUrlLocalization + '/locales',
				beforeSend: function(req) {
				           req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
				       },	
			}
		},			
		schema: {
            // data: 'data',
            // total: 'total',            
            model: model,                
        },                        
        pageSize: 10,                
        serverPaging: false,
        serverSorting: false,
        serverFiltering: false        
	};

	/**
     * Triggers the new row add for a kendo grid.
     *
     * @function addNewLocale
     */
	$scope.addNewLocale = function() {		

		// trigger the add event 
		this.localesGrid.addRow();
	};

	/**
     * Prepares the http request for adding a new locale. Handles callbacks
     *
     * @function 
     * @param { object } locale - locale to be added
     */  
	$scope.addLocale = function(locale) {
		var url =  __env.apiBaseUrlLocalization + '/locales';
		var type = 'post';
		var data = locale;

		httpService.asyncCall(url, type, data)
			.then(function(response) {		
				var dataItem = $scope.localesGrid.dataSource.at(0);		
				dataItem.set('localeId', response.data.localeId);				
				$scope.localesGrid.refresh();				
				toastr.success('Locale successfully added');				
			}).catch(function(e){				
				$scope.localesGrid.cancelChanges();
				toastr.error('The Locale could not be added');
			});			
	};

	var deleteLocaleTemplate = kendo.template(angular.element(document).find('#deleteLocaleTemplate').html());
	var deleteLocaleWindow = angular.element(document).find('#deleteLocaleWindow').kendoWindow({
	    title: 'Are you sure you want to delete this record?',
	    visible: false, //the window will not appear before its .open method is called
	    width: '450px',
	    height: '120px',
	    modal: true
	}).data('kendoWindow');	


	/**
     * Prepares the http request for deleting a locale. Handles callbacks
     *
     * @function  
     * @param { locale } deleteLocaleItem - locale to be deleted   
     */  
    function deleteLocale(deleteLocaleItem) {
    	
    	var url = __env.apiBaseUrlLocalization + '/locales/' + deleteLocaleItem.localeId;
		var type = 'delete';
		var data = '';

		httpService.asyncCall(url, type, data)
			.then(function(response) {									
					$scope.localesGrid.dataSource.remove(deleteLocaleItem);				
					deleteLocaleWindow.close();		
					toastr.success('Locale code: "' + deleteLocaleItem.code + '" successfully deleted');
			}).catch(function(e){
				deleteLocaleWindow.close();

				if(e.status == 409)//conflict due to association with a field 
				{
					toastr.error('Locale code: "' + deleteLocaleItem.code + '" already associated with a field. It can not be deleted.');					
				}
				else
					toastr.error('The Locale code: "' + deleteLocaleItem.code + '" could not be deleted');
			});				
	};

	/**
     * handles save delete for the locale grid.
     *
     * @function 
     * @param { event } e - delete row event
     */  
	function deleteItem(e) {
		e.preventDefault();
		var deleteLocaleItem = this.dataItem(angular.element(document).find(e.currentTarget).closest('tr'));
		deleteLocaleWindow.content(deleteLocaleTemplate(deleteLocaleItem)); //send the row data object to the template and render it
        deleteLocaleWindow.center().open();

        angular.element(deleteLocaleWindow.element).find('#btnOk').click(function(){
            deleteLocale(deleteLocaleItem);            
        });

        angular.element(deleteLocaleWindow.element).find('#btnCancel').click(function(){
            deleteLocaleWindow.close();
        });
	}	

	

	/**
     * handles save event for the locale grid.
     *
     * @function 
     * @param { event } e - save row event
     */  
	function saveEvent(e) {

		$scope.displayMode = true; 

		// stop kendo from being annoying
		e.preventDefault();

		if(e.model.localeId > 0) {

			// locales with an id should be updated			
			$scope.updateLocale(e.model);
		} else {
			e.model.localeId = 0;

			// locales without an id should be added
			$scope.addLocale(e.model);
		}
	}

	/**
     * Prepares the http request for updating a locale. Handles callbacks.
     *
     * @function 
     * @param { obj } locale - locale object
     */   
    $scope.updateLocale = function(locale) {   
    	var url = __env.apiBaseUrlLocalization + '/locales/' + locale.localeId;
		var type = 'put';
		var data = locale;

		httpService.asyncCall(url, type, data)
			.then(function(response) {				
				$scope.localesGrid.refresh();				
				toastr.success('Locale successfully updated');				
			}).catch(function(e){				
				$scope.localesGrid.cancelChanges();				
				toastr.error('The Locale could not be updated');
			});		
		
    };
}